<template>
  <div>
    <b-modal
      title="更新權限"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <ul
        v-for="(level1, index) in permission"
        :key="`level1-${index}`"
      >
        <li>
          <span>{{ level1.text }}</span>

          <ul
            v-for="(level2, index) in level1.children"
            :key="`level2-${index}`"
          >
            <li>
              <span>{{ level2.text }}</span>

              <div>
                <b-form-checkbox
                  v-for="(level3, index) in level2.children"
                  :key="`level3-${index}`"
                  v-model="level3.isCheck"
                  inline
                  @change="togglePermission(level1.value, level2.value, level3)"
                >
                  {{ level3.text }}
                </b-form-checkbox>
              </div>
            </li>
          </ul>
        </li>
      </ul>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit()"
        >
          確定
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$emit('change', false)"
        >
          取消
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { permission_settings } from "@/models/HELPERS/options.js";
import { getLocalUserInfo } from "@/models/HELPERS/common.js";

export default {
  name: 'PermissionEditModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {

  },
  data () {
    return {
      permission: [],
      selected: {
        contract_management: {
          search: [],
          update: []
        },
        business_management: {
          search: [],
          update: []
        },
        bill_management: {
          search: [],
          update: []
        },
        claims: {
          search: [],
          update: []
        },
        report: {
          search: [],
          update: []
        },
        set: {
          search: [],
          update: []
        },
        log: {
          search: [],
          update: []
        },
        old_system_log: {
          search: [],
          update: []
        }
      },
      test: {
        bill_management:"{\"search\":[\"bill_management\",\"unpaid_bills\",\"pay_details\",\"billing_settings\",\"current_month_bill\"],\"update\":[\"unpaid_bills\",\"billing_settings\"]}",
        business_management: "{\"search\":[\"business_management\",\"business\",\"business_organization_tree\",\"business_equity_V2\"],\"update\":[\"business\"]}",
        claims:"{\"search\":[\"claims\",\"unprocessed_mutual_aid_money\",\"claimed_aid_fund\",\"deceased_claim_form\",\"export_claim\"],\"update\":[\"unprocessed_mutual_aid_money\",\"claimed_aid_fund\"]}",
        contract_management: "{\"search\":[\"contract_management\",\"contract\",\"contract_promotion_setting\",\"notice\"],\"update\":[\"contract\",\"contract_promotion_setting\"]}",
        log: "{\"search\":[\"log\",\"contract_log\",\"business_log\",\"bill_log\"]}",
        old_system_log:"{\"search\":[\"old_system_log\",\"old_system_contract_log\",\"old_system_contract_pay_notice_address_log\",\"old_system_join_member_fee_log\",\"old_system_amount_log\",\"old_system_sales_log\"]}",
        report:"{\"search\":[\"report\",\"monthly_new_user_report\",\"monthly_deceased_user_report\",\"death_member_claim\",\"monthly_full_payment_count\",\"regional_data_report\",\"bill_data_report\",\"monthly_count_report\",\"member_age_distribution_report\",\"sales_age_distribution_report\",\"member_exclusion_paycount\",\"export_report\"]}",
        set:"{\"search\":[\"set\",\"config\",\"security_center\",\"frontend_data_setup\",\"permission_settings\"],\"update\":[\"config\",\"security_center\",\"frontend_data_setup\",\"permission_settings\"]}",
      }
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.permission = [];

          const meta = this.$route.meta;
          const info = getLocalUserInfo(meta.authority);

          const permission_settings_list = JSON.parse(JSON.stringify(permission_settings));

          this.permission = this.permissionDataHandler(permission_settings_list, this.data.permission);
        }
      },
      immediate: false
    }
  },
  methods: {
    // 權限資料處理
    permissionDataHandler(list = [], permission = {}, level_tag = []) {
      // this.permission = sideMemuData.map(item => {
      //   return {
      //       text: item.title,
      //       value: item.meta.permission_tag[0],
      //       isCheck: false,
      //       children: item.children.map(item_child => {
      //           return {
      //             text: item_child.name,
      //             value: item_child.meta.permission_tag[0],
      //             isCheck: false,
      //             permission: item_child.meta.permission_type.map(permission => {
      //               return {
      //                 text: permission === 'search' ? '查看' : '修改',
      //                 value: permission,
      //                 isCheck: false,
      //               }
      //             })
      //           }
      //       })
      //   }
      // })

      list.forEach((item, i) => {
        if (item.hasOwnProperty('isCheck')) {

          const permission_value = JSON.parse(permission[level_tag[0]]);

          // 判斷權限 permission_value 是否為物件
          if (typeof permission_value === 'object' && permission_value !== null) {
            if (item.value === 'search' && permission_value['search'] && permission_value['search'].some(el => el === level_tag[1])) {
              item.isCheck =  true;
              this.togglePermission(level_tag[0], level_tag[1], item);
            }

            if (item.value === 'update' && permission_value['update'] && permission_value['update'].some(el => el === level_tag[1])) {
              item.isCheck =  true;
              this.togglePermission(level_tag[0], level_tag[1], item);
            }
          }
        }

        if (item.children && item.children.length > 0) {
          this.permissionDataHandler(item.children, permission, [...level_tag, item.value]);
        }
      })

      return list;
    },
    // 切換權限
    togglePermission(level1_value, level2_value, permission) {
      if (permission.isCheck) {
        if (this.selected[level1_value][permission.value].length === 0 && permission.value === 'search') {
          this.selected[level1_value][permission.value].push(level1_value);
        }

        this.selected[level1_value][permission.value].push(level2_value);
      } else {
        const index = this.selected[level1_value][permission.value].indexOf(level2_value);

        this.selected[level1_value][permission.value].splice(index, 1);

        if (this.selected[level1_value][permission.value].length === 1 && permission.value === 'search') {
          this.selected[level1_value][permission.value] = [];
        }
      }
    },
    sumit() {
      this.$emit('sumit', this.selected);
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  padding-left: 20px;
  li {
    list-style: none;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      left: -12px;
      border-top: 1px solid #000;
      top: 16px;
      width: 8px;
      height: 0;
    }
    &:after {
      content: "";
      position: absolute;
      left: -12px;
      border-left: 1px solid #000;
      height: 100%;
      width: 0px;
      top: 2px;
    }
    &:last-child::after {
      height: 15px;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/PermissionEditModal.vue